import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import LocalStorage from '../../utils/localStorage';

const fnbPendingOrderKey = 'Pending_Fnb_';

class fnbStore {

    // Main Properties

    @observable menu = null;
    @observable fnbItems = [];
    @observable fnbFilterItems = [];
    @observable fnbPendingOrders = [];
    @observable fnbRemark = '';
    @observable fnbAdditionalRemark = '';
    @observable fnbLoading = false;
    @observable fnbSearchText = '';
    @observable fnbSearchSubCategory = 'All';
    @observable fnbTotalOrder = 0;

    // Fnb Detail Modal

    @observable fnbDetail = null;
    @observable showFnbDetailModal = false;
    @observable fnbAdditionalItems = [];
    @observable fnbDetailLoading = false;
    @observable fnbItemTotalPrice = 0;
    @observable fnbAddOrderLoading = false;
    @observable noOfPerson = 0;

    // Fnb Tab

    @observable fnbTabCategories = [];
    @observable fnbTabSubCategories = [];
    @observable fnbTabCategoryIdActive = '0';

    // Fnb Recommendation

    @observable fnbRecommendationItems = [];
    @observable showFnbRecommendationModal = false;
    @observable fnbTaskIdHasRecommendation = 0;

    // Fnb Confirm

    @observable fnbConfirmLoading = true;
    @observable fnbSubTotal = 0;
    @observable fnbVat = 0;
    @observable fnbVatTax = 0;
    @observable fnbServiceFee = 0;
    @observable fnbServiceFeeTax = 0;
    @observable fnbTotal = 0;

    @observable fnbTimeSelected = 'now';
    @observable fnbTimeDeliver = '';
    @observable fnbTimeDeliverDate = '';

    @observable fnbPaymentOption = 'Cash';

    // Swipe
    @observable swipeX = 0;
    @observable isSwipe = false;

    // Initialization

    @action initGetFnbs(roomNo) {
        const that = this;
        that.fnbTaskIdHasRecommendation = 0;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getInRoomDinings(languageCode).then((fnbResponses) => {
            if (fnbResponses) {
                that.menu = fnbResponses.menu;
                that.fnbTabCategories = fnbResponses.categoryNames;

                if (that.fnbTabCategoryIdActive === '0') {
                    that.fnbTabSubCategories = that.fnbTabCategories[0].subCategories;
                    that.fnbTabCategoryIdActive = that.fnbTabCategories[0].taskId.toString();
                } else {
                    const category = this.fnbTabCategories.find(fi => fi.taskId === parseInt((that.fnbTabCategoryIdActive)));
                    that.fnbTabSubCategories = category.subCategories;
                }

                that.fnbItems = fnbResponses.items;
                that.fnbFilterItems = that.fnbItems;

                if (that.fnbFilterItems.length > 0) {
                    that.fnbFilterItems.map((fnbItem) => {
                        return fnbItem.orderQuantity = 0;
                    });

                    const fnbOrders = this.getFnbPendingOrdersFromStorage(roomNo);
                    if (fnbOrders !== null) {
                        fnbOrders.map((fnbOrder) => {
                            let fnbItem = that.fnbFilterItems.find(it => it.taskId === fnbOrder.taskId);
                            if (fnbItem) {
                                fnbItem.orderQuantity = fnbOrder.orderQuantity;
                                fnbItem.additionalItems = fnbOrder.additionalItems;
                                fnbItem.additionalRemark = fnbOrder.additionalRemark;
                                fnbItem.remark = fnbOrder.remark;
                            }
                            return fnbItem;
                        })
                    }
                } else {
                    that.menu = null;
                    that.fnbTabCategories = [];
                    that.fnbTabSubCategories = [];
                    that.fnbItems = [];
                    that.fnbFilterItems = [];
                    that.fnbSearchText = '';
                    that.fnbSearchSubCategory = 'All';
                }
            } else {
                that.menu = null;
                that.fnbTabCategories = [];
                that.fnbTabSubCategories = [];
                that.fnbItems = [];
                that.fnbFilterItems = [];
                that.fnbSearchText = '';
                that.fnbSearchSubCategory = 'All';
            }

            this.searchFnbByNameAndSubCategory();
        });
    }

    @action refreshFnbs(roomNo) {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getInRoomDinings(languageCode).then((fnbResponses) => {
            if (fnbResponses) {
                that.menu = fnbResponses.menu;
                that.fnbTabCategories = fnbResponses.categoryNames;

                if (that.fnbTabCategoryIdActive === '0') {
                    that.fnbTabSubCategories = that.fnbTabCategories[0].subCategories;
                    that.fnbTabCategoryIdActive = that.fnbTabCategories[0].taskId.toString();
                } else {
                    const category = this.fnbTabCategories.find(fi => fi.taskId === parseInt((that.fnbTabCategoryIdActive)));
                    that.fnbTabSubCategories = category.subCategories;
                }

                that.fnbItems = fnbResponses.items;
                that.fnbFilterItems = that.fnbItems;

                if (that.fnbFilterItems.length > 0) {
                    that.fnbFilterItems.map((fnbItem) => {
                        return fnbItem.orderQuantity = 0;
                    });

                    const fnbOrders = this.getFnbPendingOrdersFromStorage(roomNo);
                    if (fnbOrders !== null) {
                        fnbOrders.map((fnbOrder) => {
                            let fnbItem = that.fnbFilterItems.find(it => it.taskId === fnbOrder.taskId);
                            if (fnbItem) {
                                fnbItem.orderQuantity = fnbOrder.orderQuantity;
                                fnbItem.additionalItems = fnbOrder.additionalItems;
                                fnbItem.additionalRemark = fnbOrder.additionalRemark;
                                fnbItem.remark = fnbOrder.remark;
                            }
                            return fnbItem;
                        })
                    }
                }
            } else {
                that.menu = null;
                that.fnbTabCategories = [];
                that.fnbTabSubCategories = [];
                that.fnbItems = [];
                that.fnbFilterItems = [];
                that.fnbSearchText = '';
                that.fnbSearchSubCategory = 'All';
            }

            this.searchFnbByNameAndSubCategory();
        });
    }

    @action initFnbRecommendations(taskIdList) {
        const that = this;
        that.fnbLoading = true;
        that.fnbAddOrderLoading = true;
        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.Queries.apiGetQueryRecommendationByTaskIds(taskIdList, languageCode).then((recommendationResponses) => {
            that.fnbRecommendationItems = [];

            if (recommendationResponses) {
                recommendationResponses.fnbRecommendations.map(fnbRecommendation => {
                    var fnbItem = this.fnbFilterItems.find(fi => fi.taskId === fnbRecommendation.taskId);
                    if (fnbItem) {
                        if (fnbItem.orderQuantity === 0) {
                            that.fnbRecommendationItems.push(fnbRecommendation);
                        }
                    }

                    return fnbRecommendation;
                });
            }

            that.fnbLoading = false;
            return that.fnbRecommendationItems;
        });
    }

    @action initFnbConfirm(roomNo) {
        this.fnbRemark = '';
        this.fnbTimeSelected = 'now';
        this.fnbTimeDeliver = '';
        this.fnbConfirmLoading = true;
        this.noOfPerson = 0;

        let data = LocalStorage.Get(fnbPendingOrderKey + roomNo);
        if (data !== null) {
            this.fnbPendingOrders = data;
        }

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getInRoomDining(languageCode).then(resp => {
            this.menu = resp;

            this.fnbVatTax = resp.vat;
            this.fnbServiceFeeTax = resp.serviceFee;

            this.setFnbPriceDetail();
            this.fnbConfirmLoading = false;
        });
    }

    @action initTotalFnbOrder(roomNo) {
        const orders = LocalStorage.Get(fnbPendingOrderKey + roomNo);

        if (orders) {
            let quantity = 0;
            orders.map(order => {
                quantity = quantity + order.orderQuantity;

                return order;
            });

            this.fnbTotalOrder = quantity;
        } else {
            this.fnbTotalOrder = 0;
        }
    }

    // Transaction Action

    @action goToFnbConfirmPage(roomNo) {
        const fnbItems = this.fnbItems.filter(item => item.orderQuantity > 0);
        LocalStorage.Save(fnbPendingOrderKey + roomNo, fnbItems);
        this.initTotalFnbOrder(roomNo);
        return LocalStorage.Get(fnbPendingOrderKey + roomNo);
    }

    @action goToFnbConfirmPageWithRecommendation(roomNo) {
        const fnbItems = this.fnbItems.filter(item => item.orderQuantity > 0);
        const fnbRecommendationItems = this.fnbRecommendationItems.filter(item => item.orderQuantity > 0);
        fnbRecommendationItems.map((d) => {
            return fnbItems.push(d);
        });

        LocalStorage.Save(fnbPendingOrderKey + roomNo, fnbItems);
        return LocalStorage.Get(fnbPendingOrderKey + roomNo);
    }

    @action removeFnbOrders(roomNo) {
        this.fnbItems = [];
        this.fnbFilterItems = this.fnbItems;
        LocalStorage.Remove(fnbPendingOrderKey + roomNo);
    }

    @action backToFnbMainPage(roomNo) {
        const fnbPendingOrders = this.fnbPendingOrders.filter(item => item.orderQuantity > 0);

        if (fnbPendingOrders) {
            LocalStorage.Save(fnbPendingOrderKey + roomNo, fnbPendingOrders);
        } else {
            LocalStorage.Save(fnbPendingOrderKey + roomNo, []);
        }
    }

    // GET Properties

    @action getFnbDetailByFnbTaskId(taskId) {
        this.fnbDetailLoading = true;
        this.fnbAdditionalItems = [];
        this.fnbDetail = null;

        const fnbItem = this.fnbFilterItems.find(it => it.taskId === taskId);

        if (fnbItem) {
            this.fnbDetail = fnbItem;
            this.fnbAdditionalItems = fnbItem.additionalItems;

            if (this.fnbDetail.orderQuantity === 0) {
                this.fnbDetail.orderQuantity = 1;
            }

            this.setFnbItemTotalPrice();
        }

        this.fnbDetailLoading = false;
        this.showFnbDetailModal = true;

        return fnbItem;
    }

    @action getFnbPendingOrders() {
        return this.fnbPendingOrders.filter(it => it.orderQuantity > 0);
    }

    @action getFnbPendingOrdersFromStorage(roomNo) {
        return LocalStorage.Get(fnbPendingOrderKey + roomNo);
    }

    // Set Properties
    @action setNoOfPerson(value) {
        this.noOfPerson = value;
    }

    @action setFnbRemark(value) {
        this.fnbRemark = value;
    }

    @action setFnbItemQty(taskId, value) {
        const fnbItem = this.fnbFilterItems.find(it => it.taskId === taskId);
        fnbItem.orderQuantity = value;

        this.setFnbItemTotalPrice();
    }

    @action setFnbPendingOrderQty(taskId, value) {
        const fnbPendingOrder = this.fnbPendingOrders.find(it => it.taskId === taskId);
        fnbPendingOrder.orderQuantity = value;

        this.setFnbPriceDetail();
    }

    @action setShowFnbDetailModal(value) {
        this.showFnbDetailModal = value;
    }

    @action setFnbPriceDetail() {
        this.fnbSubTotal = 0;

        this.fnbPendingOrders.map((order) => {
            if (order.price === order.specialPrice) {
                this.fnbSubTotal = this.fnbSubTotal + (order.orderQuantity * (order.price + order.additionalPrice))
            } else {
                this.fnbSubTotal = this.fnbSubTotal + (order.orderQuantity * (order.specialPrice + order.additionalPrice))
            }

            return this.fnbSubTotal;
        });

        this.fnbServiceFee = this.fnbSubTotal * this.fnbServiceFeeTax / 100;
        this.fnbVat = (this.fnbSubTotal + this.fnbServiceFee) * this.fnbVatTax / 100;

        this.fnbTotal = this.fnbSubTotal + this.fnbServiceFee + this.fnbVat;
    }

    @action setFnbTimeSelected(value) {
        this.fnbTimeSelected = value
        this.fnbTimeDeliver = ''
    }

    @action setFnbTimeDeliver(value) {
        this.fnbTimeDeliver = value
        this.fnbTimeSelected = ''
    }

    @action setFnbTimeDeliverDate(value) {
        this.fnbTimeDeliverDate = value
    }

    @action setShowFnbRecommendationModal(value) {
        this.showFnbRecommendationModal = value;
    }

    @action setFnbRecommendationQty(taskId, value) {
        const fnbRecommendationItem = this.fnbRecommendationItems.find(it => it.taskId === taskId);
        fnbRecommendationItem.orderQuantity = value;
    }

    @action setRadioButtonSelected(fnbAdditionalItemId, fnbAdditionalItemDetailId) {
        const fnbAdditionalItem = this.fnbDetail.additionalItems.find(fi => fi.fnbAdditionalItemId === fnbAdditionalItemId);
        if (fnbAdditionalItem) {
            fnbAdditionalItem.itemDetails.map(itemDetail => {
                if (itemDetail.fnbAdditionalItemDetailId === fnbAdditionalItemDetailId) {
                    itemDetail.isSelected = true;
                } else {
                    itemDetail.isSelected = false;
                }
                return itemDetail;
            });
        }

        this.setFnbItemTotalPrice();
    }

    @action setCheckSelected(fnbAdditionalItemId, fnbAdditionalItemDetailId, isChecked) {
        const fnbAdditionalItem = this.fnbDetail.additionalItems.find(fi => fi.fnbAdditionalItemId === fnbAdditionalItemId);
        if (fnbAdditionalItem) {
            const itemDetail = fnbAdditionalItem.itemDetails.find(fi => fi.fnbAdditionalItemDetailId === fnbAdditionalItemDetailId);

            if (isChecked) {
                const selectedItemDetail = fnbAdditionalItem.itemDetails.filter(fi => fi.isSelected);
                const totalSelectedItemDetail = selectedItemDetail.length;
                if (totalSelectedItemDetail < fnbAdditionalItem.maxNumber) {
                    itemDetail.isSelected = isChecked;
                }
            } else {
                itemDetail.isSelected = isChecked;
            }
        }

        this.setFnbItemTotalPrice();
    }

    @action setFnbItemTotalPrice() {
        let additionalPrice = 0;

        if (this.fnbDetail.additionalItems) {
            this.fnbDetail.additionalItems.map(item => {
                item.itemDetails.map(itemDetail => {
                    if (itemDetail.isSelected) {
                        additionalPrice = additionalPrice + itemDetail.price;
                    }
                    return itemDetail;
                });
                return item;
            });
        }

        if (this.fnbDetail.price === this.fnbDetail.specialPrice) {
            this.fnbItemTotalPrice = this.fnbDetail.orderQuantity * (this.fnbDetail.price + additionalPrice);
        } else {
            this.fnbItemTotalPrice = this.fnbDetail.orderQuantity * (this.fnbDetail.specialPrice + additionalPrice);
        }

        this.fnbDetail.additionalPrice = additionalPrice;

    }

    @action setFnbAdditionalRemark() {
        this.fnbAdditionalRemark = '';

        if (this.fnbDetail.additionalItems) {
            this.fnbDetail.additionalItems.map(item => {
                item.itemDetails.map(itemDetail => {
                    if (itemDetail.isSelected) {
                        if (this.fnbAdditionalRemark === '') {
                            this.fnbAdditionalRemark = `${itemDetail.subItemName}, `;
                        } else {
                            this.fnbAdditionalRemark = `${this.fnbAdditionalRemark}${itemDetail.subItemName}, `;
                        }
                    }
                    return itemDetail;
                })
                return item;
            });
        }

        this.fnbDetail.additionalRemark = this.fnbAdditionalRemark;
    }

    @action setRemark(value) {
        this.fnbDetail.remark = value;
    }

    @action setFnbTaskIdHasRecommendation(value) {
        this.fnbTaskIdHasRecommendation = value;
    }

    @action searchFnbByNameAndSubCategory() {
        if (this.fnbSearchText === '' && this.fnbSearchSubCategory === 'All') {
            this.fnbFilterItems = this.fnbItems;
            return;
        }

        if (this.fnbSearchSubCategory === 'All') {
            this.fnbFilterItems = this.fnbItems;
        } else {
            this.fnbFilterItems = this.fnbItems.filter(item => {
                let subCategoryName = item.subCategoryName.toLowerCase();
                return subCategoryName.indexOf(this.fnbSearchSubCategory.toLowerCase()) !== -1;
            });
        }

        if (this.fnbSearchText !== '') {
            this.fnbFilterItems = this.fnbFilterItems.filter(item => {
                let itemTaskName = item.taskName.toLowerCase();
                return itemTaskName.indexOf(this.fnbSearchText.toLowerCase()) !== -1;
            });
        }
    }

    @action setFnbSearchText(value) {
        this.fnbSearchText = value;
    }

    @action setFnbSearchSubCategory(value) {
        this.fnbSearchSubCategory = value;
    }

    @action setFnbTabSubCategoriesByTabCategoryTaskId(tabCategoryTaskId) {
        this.fnbTabCategoryIdActive = tabCategoryTaskId.toString();
        const category = this.fnbTabCategories.find(fi => fi.taskId === parseInt(tabCategoryTaskId));

        if (category) {
            if (category.subCategories.length > 0) {
                this.fnbTabSubCategories = category.subCategories;
                return;
            }
        }

        this.fnbTabSubCategories = [];
    }

    @action setFnbPaymentOption(value) {
        this.fnbPaymentOption = value;
    }

    @action setSwipeX(value) {
        this.swipeX = value;
    }

    @action setIsSwipe(value) {
        this.isSwipe = value;
    }

    @action setFnbAddOrderLoading(value) {
        this.fnbAddOrderLoading = value;
    }

    @action setfnbConfirmLoading(value) {
        this.fnbConfirmLoading = value;
    }

    // RESET Properties

    @action resetData() {
        this.menu = null;
        this.showFnbDetailModal = false;
        this.fnbTabCategories = [];
        this.fnbTabSubCategories = [];
        this.fnbItems = [];
        this.fnbFilterItems = [];
        this.fnbSearchText = '';
        this.fnbSearchSubCategory = 'All';
        this.searchFnbByNameAndSubCategory();
    }

    // Check the availability of items in the shopping cart
    @action async checkCartItemsAvailability(roomNo, pageName = 'Unknown') {
        if (!roomNo) {
            //console.log(`${pageName}: roomNo 为空，无法检查购物车`);
            return { success: false, error: 'No room number' };
        }

        const fnbPendingOrders = this.getFnbPendingOrdersFromStorage(roomNo);
        if (!fnbPendingOrders || fnbPendingOrders.length === 0) {
            //console.log(`${pageName}: 购物车为空，无需检查`);
            return { success: true, isEmpty: true };
        }

        //console.log(`${pageName}: 检查购物车商品可用性`, fnbPendingOrders);

        try {
            const languageCode = window.localStorage.getItem('lang') || 'en';
            const response = await ApiCaller.CmsTasks.getInRoomDinings(languageCode);

            if (response && response.items) {
                const latestItems = response.items;
                //console.log(`${pageName}: 获取到最新商品数据`, latestItems.length, '个商品');

                const unavailableItems = [];
                fnbPendingOrders.forEach(cartItem => {
                    const latestItem = latestItems.find(item => item.taskId === cartItem.taskId);
                    if (latestItem) {
                        //console.log(`${pageName}: 检查商品 ${cartItem.taskName} (ID: ${cartItem.taskId})`,
                            //`购物车中: ${cartItem.isAvailable}, 最新: ${latestItem.isAvailable}`);

                        if (!latestItem.isAvailable) {
                            unavailableItems.push({
                                ...cartItem,
                                latestData: latestItem
                            });
                        }
                    } else {
                        //console.log(`${pageName}: 商品 ${cartItem.taskName} (ID: ${cartItem.taskId}) 在最新数据中未找到`);
                        unavailableItems.push({
                            ...cartItem,
                            notFound: true
                        });
                    }
                });

                if (unavailableItems.length > 0) {
                    //console.log(`${pageName}: 发现不可用商品:`, unavailableItems);

                    const unavailableTaskIds = unavailableItems.map(item => item.taskId);
                    const availableItems = fnbPendingOrders.filter(item => !unavailableTaskIds.includes(item.taskId));

                    LocalStorage.Save(fnbPendingOrderKey + roomNo, availableItems);

                    unavailableTaskIds.forEach(taskId => {
                        const fnbItem = this.fnbItems.find(item => item.taskId === taskId);
                        if (fnbItem) {
                            fnbItem.orderQuantity = 0;
                            fnbItem.isAvailable = false;
                        }
                    });

                    //console.log(`${pageName}: 已自动移除 ${unavailableItems.length} 个不可用商品`);
                    //console.log(`${pageName}: 移除的商品:`, unavailableItems.map(item => `${item.taskName} (ID: ${item.taskId})`));

                    return {
                        success: true,
                        hasUnavailableItems: true,
                        unavailableItems,
                        removedCount: unavailableItems.length,
                        availableCount: availableItems.length,
                        totalCount: fnbPendingOrders.length
                    };
                } else {
                    //console.log(`${pageName}: 购物车中所有商品都可用`);
                    return {
                        success: true,
                        hasUnavailableItems: false,
                        availableCount: fnbPendingOrders.length,
                        totalCount: fnbPendingOrders.length
                    };
                }
            } else {
                console.error(`${pageName}: API 返回数据格式错误`);
                return { success: false, error: 'Invalid API response' };
            }
        } catch (error) {
            console.error(`${pageName}: 检查商品可用性时出错:`, error);
            return { success: false, error: error.message };
        }
    }
}

export default new fnbStore()